import axiosInstance from '../axiosInstance';

export const postNewQuestion = async (data) => {
  try {
    const response = await axiosInstance.post('/qna', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data.data;
  } catch (error) {
    console.error('Post QnA API Error:', error);
    throw error;
  }
};

export const getQuestionList = async ({
  categoryId,
  sort,
  onlyAnswered,
  onlyUnanswered,
  page = 0,
} = {}) => {
  try {
    const response = await axiosInstance.get('/qna', {
      params: {
        ...(categoryId && { categoryId }),
        ...(sort && { sort }),
        ...(onlyAnswered !== undefined && { onlyAnswered }),
        ...(onlyUnanswered !== undefined && { onlyUnanswered }),
        page,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Get QnA List API Error:', error);
    throw error;
  }
};

export const getQuestionDetail = async (qnaId) => {
  try {
    const response = await axiosInstance.get(`/qna/${qnaId}`);

    const etag = response.headers?.etag;
    if (etag) sessionStorage.setItem(`etag:/qna/${qnaId}`, etag);

    return response.data.data;
  } catch (error) {
    console.error('Get QnA Detail Error:', error);
    throw error;
  }
};

export const updateQuestion = async (qnaId, data) => {
  try {
    const response = await axiosInstance.put(`/qna/${qnaId}`, data);
    return response.data.data;
  } catch (error) {
    console.error('Update Question Error:', error);
    throw error;
  }
};

export const deleteQuestion = async (qnaId) => {
  try {
    const response = await axiosInstance.delete(`/qna/${qnaId}`);
    return response.data.data;
  } catch (error) {
    console.error('Delete Question Error:', error);
    throw error;
  }
};

export const getUserLikeList = async (userId) => {
  try {
    const response = await axiosInstance.get(`/qna/likes`, {
      params: { userId },
    });
    return response.data.data;
  } catch (error) {
    console.error('Add QnA Like Error:', error);
    throw error;
  }
};

export const getSingleQnaLike = async (qnaId, userId) => {
  try {
    const response = await axiosInstance.get(`/qna/${qnaId}/like`, {
      params: { userId },
    });
    return response.data.data;
  } catch (error) {
    console.error('Add QnA Like Error:', error);
    throw error;
  }
};

export const addQnaLike = async (qnaId) => {
  try {
    const response = await axiosInstance.post(`/qna/${qnaId}/like`, null);
    return response.data.data;
  } catch (error) {
    console.error('Add QnA Like Error:', error);
    throw error;
  }
};

export const removeQnaLike = async (qnaId, userId) => {
  try {
    const response = await axiosInstance.delete(`/qna/${qnaId}/like`);
    return response.data.data;
  } catch (error) {
    console.error('Remove QnA Like Error:', error);
    throw error;
  }
};

export const hideQuestion = async (qnaId) => {
  try {
    const response = await axiosInstance.put(`/qna/${qnaId}/hide`);
    return response.data.data;
  } catch (error) {
    console.error('Hide QnA Question Error:', error);
    throw error;
  }
};

export const unhideQuestion = async (qnaId) => {
  try {
    const response = await axiosInstance.put(`/qna/${qnaId}/unhide`);
    return response.data.data;
  } catch (error) {
    console.error('Unhide QnA Question Error:', error);
    throw error;
  }
};

export const updateOnlyTutor = async (qnaId, onlyTutor) => {
  try {
    const response = await axiosInstance.put(`/qna/${qnaId}/only-tutor`, null, {
      params: { onlyTutor },
    });
    return response.data.data;
  } catch (error) {
    console.error('Update OnlyTutor QnA Question Error:', error);
    throw error;
  }
};

export const getMyQuestionList = async (limit, page) => {
  try {
    const response = await axiosInstance.get(`/qna/my`, {
      params: {
        limit: limit,
        offset: page,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Get My QnA List API Error:', error);
    throw error;
  }
};
